import { AxiosError } from 'axios';
import api from '../utils/api';
import { Lookup, CreateLookupDTO, LookupType } from '../types/lookup.types';

// Base URLs for different lookup endpoints
const PUBLIC_BASE_URL = '/lookups/public';
const PROTECTED_BASE_URL = '/lookups';

// Fetch all lookups (protected)
export const getAllLookups = async (): Promise<Lookup[]> => {
  
  try {
    const response = await api.get<{ data: Lookup[] }>(PROTECTED_BASE_URL);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Fetch lookups by type (protected)
export const getLookupsByType = async (type: LookupType): Promise<Lookup[]> => {
  
  try {
    const url = `${PROTECTED_BASE_URL}/${type}`;
    const response = await api.get<{ data: Lookup[] }>(url);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Create a new lookup (protected)
export const createLookup = async (lookup: CreateLookupDTO): Promise<Lookup> => {
  
  try {
    const response = await api.post<{ data: Lookup }>(PROTECTED_BASE_URL, lookup);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Update a lookup (protected)
export const updateLookup = async (id: string, lookup: Partial<CreateLookupDTO>): Promise<Lookup> => {
  
  try {
    const url = `${PROTECTED_BASE_URL}/${id}`;
    const response = await api.put<{ data: Lookup }>(url, lookup);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Delete a lookup (protected)
export const deleteLookup = async (id: string): Promise<void> => {
  
  try {
    const url = `${PROTECTED_BASE_URL}/${id}`;
    await api.delete(url);
    
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Toggle lookup active status (protected)
export const toggleLookupStatus = async (id: string): Promise<Lookup> => {
  
  try {
    const url = `${PROTECTED_BASE_URL}/${id}/toggle`;
    const response = await api.patch<{ data: Lookup }>(url);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Reorder lookups (protected)
export const reorderLookups = async (type: LookupType, orderedIds: string[]): Promise<Lookup[]> => {
  
  try {
    const url = `${PROTECTED_BASE_URL}/reorder/${type}`;
    const response = await api.post<{ data: Lookup[] }>(url, { orderedIds });
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};

// Get active lookups by type (public)
export const getActiveLookupsByType = async (type: LookupType): Promise<Lookup[]> => {
  
  try {
    const url = `${PUBLIC_BASE_URL}/${type}`;
    const response = await api.get<{ data: Lookup[] }>(url);
    
    return response.data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    /* removed console.error */
    throw error;
  }
};